import Vue from "vue";
import Router from "vue-router";

import pageNotFound from "./pages/pageNotFound";
import HomePage from "@/pages/HomePage.vue";
import UserOrderPage from './pages/userOrdersPage'
import CartPage from '@/pages/cartPage'

import products from './modules/products/products.module';
import users from './modules/users/users.module';
import orders from './modules/orders/orders.module';
import conf from './modules/conf/conf.module';

const routes = [
    {
        path: "/",
        name: "home",
        component: HomePage
    },
    {
        path: '/meus-pedidos',
        name: 'user.orders',
        component: UserOrderPage
    },
    {
        path: "/carrinho",
        name: "cart",
        component: CartPage
    },
    {
        path: "*",
        name: 'notFound',
        component: pageNotFound
    }
];

const router = new Router({
    routes,
    linkActiveClass: "is-active",
    mode: "history"
});

router.addRoutes(conf.routes);
router.addRoutes(products.routes);
router.addRoutes(users.routes);
router.addRoutes(orders.routes);

Vue.use(Router);
export default router;
